/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React, { Fragment } from 'react';
import { Label } from 'reactstrap';
import { Field } from 'redux-form';
import {
  emptyOrEmail,
  required,
} from '@hbrisk/sp3-risk-model-support/utility/form/validation/fieldValidators/index.js';
import { FieldFeedback, RenderInput } from '#components/support/forms/utility/index.js';
import trimAndToLower from '#support/utility/string/trimAndToLower.js';

type Props = {|
  form: string,
|};

const EmailField = ({ form }: Props): Element<typeof Fragment> => (
  <>
    <Label htmlFor="email">Email</Label>
    <Field
      id="email"
      name="email"
      type="text"
      component={RenderInput}
      validate={[required, emptyOrEmail]}
      normalize={trimAndToLower}
    />
    <FieldFeedback name="email" form={form} />
  </>
);

export default EmailField;
